import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

export default function CGUPage(props) {
  return (
    <div id="cgu">
      <h1>CONDITIONS GÉNÉRALES D’UTILISATION PAYMYTABLE</h1>

      <p className="subtitle">
        LES PRÉSENTES CONDITIONS GÉNÉRALES D’UTILISATION DÉCRIVENT LES CONDITIONS
        DANS LESQUELLES LES UTILISATEURS PARTICULIERS BÉNÉFICIENT DES SERVICES PAYMYTABLE.
        ELLES DOIVENT IMPÉRATIVEMENT ÊTRE LUES ET ACCEPTÉES.
      </p>

      <h2>1. Objet</h2>

      <p>
        Les présentes Conditions Générales d’Utilisation (ci-après les <b>CGU</b>) visent à décrire les conditions d’utilisation des services proposés par PAYMYTABLE, société par actions simplifiée au capital social de 1,000 euros dont le siège social est situé au 4 rue Amont-Thiéville, 75017 Paris, immatriculée au registre du commerce et des sociétés de Paris sous le numéro 809 471 121 (ci-après <b>PAYMYTABLE</b>). Les services proposés permettent aux Utilisateurs Particuliers PAYMYTABLE :

        <ul>
          <li>
            de régler leur addition en totalité ou en partie,par l’intermédiaire d’un compte de monnaie électronique, en se connectant sur l’application PAYMYTABLE à la fin du repas ;
          </li>

          <li>
            de localiser les établissements acceptant le mode de paiement PAYMYTABLE ;
          </li>

          <li>
            de bénéficier d’offres promotionnelles.
          </li>
        </ul>

        Durant la phase de pré déploiement du Service PAYMYTABLE qui s’achève le […], PAYMYTABLE ne peut garantir le parfait fonctionnement de son Service, ce que son Utilisateur Particulier, ayant choisi de participer à ladite expérimentation, accepte par avance.
      </p>

      <h2>2.                  Définitions</h2>

      <p>Pour les besoins des présentes CGU, les mots ou expressions suivants ont le sens qui leur est attribué ci-dessous :</p>

      <p>
        <b>Achat de Monnaie Électronique :</b> une opération visant la recharge du Compte de Monnaie Électronique de l’Utilisateur Particulier du montant renseigné par ce dernier sur l’Application mobile PAYMYTABLE en vue du paiement d’un Bénéficiaire.
      </p>

      <p>
        <b>Application mobile :</b> programme téléchargeable et exécutable à partir du système d’exploitation d’un appareil électronique mobile, ci-après appelé « Smartphone », qui permet une connexion à internet.
      </p>

      <p>
        <b>Banque :</b> Crédit Mutuel Arkéa et ING Luxembourg ou tout autre établissement de crédit agréé dans un pays membre de l’Espace Économique Européen, que l’Émetteur pourrait lui substituer à l'avenir.
      </p>

      <p>
        <b>Bénéficiaire :</b> Utilisateur Professionnel au profit duquel est transférée la Monnaie Électronique dans le cadre d’une Opération de Paiement.
      </p>

      <p>
        <b>Carte bancaire :</b> une carte de paiement ou de crédit, valable en France et en cours de validité, sous réserve de son acceptation par l’Émetteur.
      </p>

      <p>
        <b>Conditions Générales d’Utilisation ou Contrat :</b> les présentes Conditions Générales d’Utilisationétant entendu que celles-ci intègrent les Conditions Particulières d’Utilisation telles que décrites à l’article 8.
      </p>

      <p>
        <b>Compte :</b> le compte de monnaie électronique créé au nom de l’Utilisateur sur demande du Distributeur.
      </p>

      <p>
        <b>Distributeur :</b> PAYMYTABLE SAS, exploitant le Site et offrant à ses Utilisateurs d’ouvrir un compte, d’acquérir de la Monnaie Électronique émise par l’Émetteur par l’intermédiaire du Site et d’utiliser la Monnaie Électronique en vue de réaliser une Opération de Paiement auprès d’un Utilisateur Professionnel.
      </p>

      <p>
        <b>Émetteur :</b> Leetchi Corp. SA, société anonyme de droit luxembourgeois, au capital de 500,000 euros, dont le siège social est situé 14 rue Aldringen, L-1118 Luxembourg, immatriculée au registre du commerce et des sociétés luxembourgeois sous le numéro B173459, agréé en tant qu’Établissement de Monnaie Électronique par la Commission de Surveillance du Secteur Financier du Luxembourg et habilitée à exercer en France  par  l’Autorité de Contrôle Prudentiel et de Résolution sous la référence 74521.
      </p>

      <p>
        <b>Espace personnel :</b> l’espace personnel de l’Utilisateur sur le Site accessible par la saisine des Identifiants de connexion et permettant l’accès aux Services PAYMYTABLE.
      </p>

      <p>
        <b>Identifiant :</b> les données nécessaires à l’identification d’un Utilisateur par l’Émetteur se composant d'un User (adresse email valide) et d'un mot de passe.
      </p>

      <p>
        <b>Jour ouvré :</b> un jour calendrier, à l’exception des samedis, dimanches et jours fériés en France métropolitaine.
      </p>

      <p>
        <b>MANGOPAY :</b> l’interface de programmation (Application Programming Interface) mis à la disposition de PAYMYTABLE par l’Émetteur pour les besoins de la mise en œuvre sur le site d’une fonctionnalité de paiement par émission de Monnaie Électronique.
      </p>

      <p>
        <b>Monnaie Électronique :</b> la valeur monétaire stockée sous forme électronique sur le serveur de l’Émetteur et représentant une créance de l’Utilisateur sur ce dernier. La Monnaie Électronique est émise par l’Émetteur contre la remise des fonds correspondants par l’Utilisateur.
      </p>

      <p>
        <b>Opération de Paiement :</b> le paiement à partir du Compte Électronique d’un Utilisateur vers le Compte Électronique PAYMYTABLE en vue de créditer le Compte Électronique du Restaurateur.
      </p>

      <p>
        <b>Remboursement :</b> l’opération de remboursement par l’Émetteur de tout ou partie de la créance de Monnaie Électronique détenue par un Utilisateur.
      </p>

      <p>
        <b>Retrait :</b> une demande de virement sur son compte bancaire par le Bénéficiaire de tout ou partie du montant de sa créance de Monnaie Électronique sur l’Émetteur, diminué des frais applicables, et en tout état de cause dans la limite de la règlementation applicable.
      </p>

      <p>
        <b>Site :</b> Application mobile ou site internet PAYMYTABLE permettant l’accès aux Services PAYMYTABLE.
      </p>

      <p>
        <b>Services :</b> l’ensemble des services fournis par PAYMYTABLE, payants ou gratuits.
      </p>

      <p>
        <b>Transaction :</b> transaction conclue par un Utilisateur Particulier et un Utilisateur Professionnel dans les conditions visées aux présentes et donnant lieu à une Opération de Paiement.
      </p>

      <p>
        <b>Utilisateur :</b> tout utilisateur PAYMYTABLE, Particulier ou Professionnel.
      </p>

      <p>
        <b>Utilisateur Particulier :</b> personne physique ayant installé l’Application Mobile PAYMYTABLE et ayant lu et accepté les présentes Conditions Générales d’Utilisation.
      </p>

      <p>
        <b>Utilisateur Professionnel :</b> tout commerçant acceptant le mode de paiement PAYMYTABLE et ayant accepté les Conditions Générales de Vente.
      </p>


      <h2>3. Champ d’application</h2>

      <p>
        Les présentes CGU s’appliquent sans restriction ni réserve, à l’ensemble des Services proposées par PAYMYTABLE sur son Site.
      </p>

      <p>
        Ces CGU prévalent sur toutes autres conditions générales ou particulières non expressément agréées par PAYMYTABLE. Nous attirons votre attention sur le fait que seuls les Utilisateurs ayant lu et accepté les présentes CGU peuvent bénéficier des Services proposés par PAYMYTABLE.
      </p>

      <h2>4. Identifiant et mot de passe</h2>

      <p>
        Lors de son inscription aux Services PAYMYTABLE, l’Utilisateur sera invité à créer un identifiant et un mot de passe lui permettant d’accéder à son Espace Personnel. Ces identifiants sont personnels et confidentiels. Ils ne peuvent être changés que sur demande de l’Utilisateur ou à l’initiative de PAYMYTABLE.
      </p>

      <p>
        L’Utilisateur est seul et entièrement responsable de l’utilisation des identifiants le concernant et s’engage à mettre tout en œuvre pour conserver secret ses identifiants et à ne pas les divulguer, à qui que ce soit, sous quelque forme que ce soit et pour quelque raison que ce soit.
      </p>

      <p>
        Par ailleurs, PAYMYTABLE recommande aux Utilisateurs de paramétrer un mot de passe à 4 chiffres qui s’activera à chaque ouverture de l’Application.
      </p>

      <p>
        L’Utilisateur sera responsable de l’utilisation de ses identifiants par des tiers ou des actions ou déclarations faites par l’intermédiaire de son Compte PAYMYTABLE, qu’elles soient frauduleuses ou non et garantir PAYMYTABLE contre toute demande à ce titre.
      </p>

      <p>
        PAYMYTABLE n’ayant pas l’obligation et en disposant pas des moyens techniques de vérification des identités des personnes qui s’inscrivent sur son Site, celui-ci ne sera pas responsable en cas d’usurpation d’identité de l’Utilisateur. Si l’Utilisateur a des raisons de penser que son identité a été frauduleusement utilisée, il doit en informer PAYMYTABLE immédiatement.
      </p>

      <p>
        En cas de perte ou de vol de son Smartphone, l’Utilisateur est responsable de toute conséquence dommageable de cette perte ou de ce vol, et doit utiliser la procédure adéquate afin de changer ses identifiants.
      </p>

      <p>
        Dans l’hypothèse où il aurait connaissance de l’accès d’une autre personne à son Espace Personnel, l’Utilisateur en informera immédiatement le responsable du Site par e-mail à l’adresse […].
      </p>

      <h2>5. Fonctionnement des paiements</h2>

      <p>
        Lorsque l’Utilisateur souhaite régler son addition, il ouvrira l’Application PAYMYTABLE et suivra les instructions. PAYMYTABLE offre la possibilité à ses Utilisateurs soit de régler la totalité de l’addition soit de partager celle-ci avec d’autres Utilisateurs Particuliers.
      </p>

      <p>
        Le Compte de Monnaie Électronique sera automatiquement rechargé du montant renseigné par l’Utilisateur  en vue du paiement de l’Utilisateur Professionnel.
      </p>

      <h2>6. Compte PAYMYTABLE limité</h2>

      <p>
        Le compte créé par défaut est un compte limité, permettant à l’Utilisateur d’effectuer des Opérations de paiement dans les limites de 2 500 (deux mille cinq cent) euros par année civile et d’effectuer des remboursements d’un montant maximum de 1000 (mille) euros par année civile.
      </p>

      <p>
        Lorsque l’Utilisateur souhaite dépasser ces montants il sera invité à fournir les documents requis par loi dont les détails se trouvent ci-dessous à l’article 8.3.3.
      </p>

      <h2>7. Compte PAYMYTABLE illimité</h2>

      <p>
        Lorsqu’un Utilisateur aura fourni toute la documentation requise par la loiil pourra bénéficier des Services PAYMYTABLE sans limitation de montant.
      </p>

      <h2>8. Conditions particulières d’utilisation de la Monnaie Électronique</h2>

      <p>
        Vous trouverez ci-dessous les conditions particulières tenant à la création et à l’utilisation de la Monnaie Électronique émise par l’Émetteur et mise à disposition de l’Utilisateur par l’intermédiaire de MANGOPAY.
      </p>

      <p>
        Les présentes Conditions Particulières d’Utilisation sont conclues entre :
      </p>

      <p>
        Le client, personne physique majeure capable, utilisant la monnaie électronique émise par Leetchi Corp. S.A à travers la solution MANGOPAY., en son propre nom ou pour le compte d’une personne morale ou une association, ci-après dénommé « Vous » ou l’« Utilisateur », d’une part ;
      </p>


      <p>
        Leetchi Corp. S.A., société anonyme de droit luxembourgeois, au capital de 500 000 euros, dont le siège social est situé 14 rue Aldringen, L-1118 Luxembourg. et immatriculée au registre du commerce et des sociétés luxembourgeois sous le numéro B173459, ci-après dénommée « Leetchi» ou « l’Émetteur», d’autre part ;
      </p>

      <p>
        Ci-après ensemble dénommées les « Parties »,
      </p>

      <p>
        Veuillez lire attentivement les présentes Conditions Particulières du service MANGOPAY et d'Utilisation de la Monnaie Électronique. Si vous souhaitez devenir Utilisateur, vous devez lire les présentes Conditions Particulièresd'Utilisation et les accepter dans le cadre du processus d'inscription. Vous déclarez que vous êtes résident enFrance. Le cas échéant, vous vous engagez à quitter le site réservé à ces utilisateurs et à vous connecter sur le site correspondant à votre pays de résidence sur lequel vous trouverez les conditions générales d’utilisation qui vous sont applicables.
      </p>

      <h3>8.1 Objet</h3>

      <p>
        Les présentes Conditions Particulières d’Utilisation ont pour objet de définir les conditions dans lesquelles l’Émetteur fournit à l’Utilisateur les services d’émission, utilisation et gestion de la Monnaie Électronique émise par l’Émetteur, pour les besoins des Opérations de Paiement.
      </p>

      <p>
        Les présentes Conditions Particulières constituent l'intégralité du Contrat conclu entre les Parties au titre de l’émission, de l’utilisation et de la gestion de la Monnaie Électronique émise par l’Émetteur ; elles sont incorporées par référence aux Conditions Générales du Site liant le Distributeur et l’Utilisateur au titre des modalités de paiement afférentes aux Transactions.
      </p>

      <p>
        L’Utilisateur peut à tout moment et sans frais se procurer une copie de ces documents en se rendant sur le Site.
      </p>

      <p>
        Seul le Contrat fera foi entre les Parties en cas de litige.
      </p>

      <h3>8.2 Inscription de l’Utilisateur</h3>

      <h4>8.2.1        Conditions nécessaires et préalables à l’inscription</h4>

      <p>
        Afin de s’inscrire, l’Utilisateur doit être une personne physique âgée d’au moins 18 (dix-huit) ans et être juridiquement capable. Il déclare agir pour son compte pendant toute la durée du Contrat.
      </p>

      <h4>8.2.2 Procédure d’inscription et d’ouverture d’un Compte d’Utilisateur</h4>

      <p>
        Lors de son inscription, l’Utilisateur devra notamment transmettre son nom, prénom, adresse mail et date de naissance ; nationalité ; pays de résidence.
      </p>

      <p>
        L’Utilisateur devra indiquer un Identifiant, composé d'un User (adresse email valide) et un mot de passe. Il est entièrement responsable du maintien de la confidentialité de son Identifiant. Il accepte de ne pas utiliser lesComptes, nom ou Identifiant d'un autre utilisateur à aucun moment, ni de divulguer son Identifiant à un tiers. Il accepte d'avertir immédiatement le Distributeur, dans le cas où il soupçonne une utilisation non autorisée de sonIdentifiant à l’adresse suivante : [Adresse service Client]. Il est seul responsable de toute utilisation de son Identifiant.
      </p>

      <p>
        En acceptant les présentes Conditions Particulières d’Utilisation, vous acceptez que le Distributeur réalise votre inscription au service de l’Émetteur dès qu’il le jugera nécessaire. La création de votre Compte Utilisateur formalise la formation du Contrat. L’Émetteur et le Distributeur pourront, sans motivation, ni droit à indemnité pour l’Utilisateur, ne pas donner suite à une demande d’inscription. L’Émetteur se réserve à tout moment le droit de demander, par l’intermédiaire du Distributeur, des informations et données d’identification complémentaires, ainsi que toutes pièces justificatives qu’il estimera utiles.
      </p>

      <p>
        L’Utilisateur déclare au moment de son inscription et pendant toute la durée du Contrat :

        <ul className="no-list-type">
          <li>(a) qu’il est âgé d'au moins 18 (dix-huit) ans ;</li>

          <li>(b) que toutes les informations fournies lors de son inscription sont sincères et exactes et à jour.</li>
        </ul>
      </p>

      <h4>8.2.3 Limites d’utilisation du Compte de Monnaie Électronique</h4>

      <p>
        Tant que l’Utilisateur n’aura pas transmis les documents visés ci-après requis par l’Émetteur et lui permettant de contrôler son identité, les limites suivantes s’imposeront à l’Utilisateur :

        <ul className="no-list-type">
          <li>
            · un montant total de 2.500 euros maximum de Monnaie Électronique détenue par un Utilisateur aucours d’une même année civile par l’intermédiaire du même Site, et
          </li>

          <li>
            · un montant total de 1.000 euros maximum de remboursement de Monnaie Électronique au cours d’une même année civile par l’intermédiaire du même Site.
          </li>
        </ul>
      </p>

      <p>
        A réception des documents suivants sous réserve qu’ils soient jugés satisfaisants par l’Émetteur, celui-ci pourra débloquer les limites applicables à l’Utilisateur personne physique :

        <ul className="no-list-type">
          <li>
            · une copie d’un document officiel d’identité en cours de validité : pour les citoyens français, carted’identité française (recto-verso), pour les étrangers résidant en France ou à l’étranger, passeport,
          </li>
        </ul>
      </p>

      <p>
        Si le Bénéficiaire n’est pas le bénéficiaire effectif des fonds, l’identité du bénéficiaire effectif avec une copie de sa pièce d’identité française ou de passeport si le bénéficiaire effectif est étranger, etéventuellement,
        <ul className="no-list-type">
          <li>
            · un justificatif de domicile qui pourra être demandé à la discrétion de l’Émetteur.
          </li>
        </ul>
      </p>

      <p>
        A réception des documents suivants sous réserve qu’ils soient jugés satisfaisants par l’Émetteur, celui-ci pourradébloquer les limites applicables à l’Utilisateur personne morale:

        <ul className="no-list-type">
          <li>
            · les statuts
          </li>

          <li>
            · un extrait récent du registre de commerce,
          </li>

          <li>
            · l’adresse du siège social et droit régissant la constitution et le fonctionnement de la société,
          </li>

          <li>
            · justificatif d’identité du dirigeant ou de la personne ayant pouvoir pour engager la société dans le cadredes opérations réalisées.
          </li>

          <li>
            · un relevé d’identité bancaire au nom de la société,
          </li>

          <li>
            · déclaration de l’ensemble des bénéficiaires économiques détenant plus de 10% du capital, signé par leou les dirigeants et obtention d’une pièce justificative d’identité des bénéficiaires effectifs personnesphysiques pourra être demandé à la discrétion de l’Émetteur.
          </li>
        </ul>

      </p>

      <p>
        A réception des documents suivants sous réserve qu’ils soient jugés satisfaisants par l’Émetteur, celui-ci pourra débloquer les limites applicables à l’Utilisateur association:

        <ul className="no-list-type">
          <li>
            · statuts
          </li>

          <li>
            · justificatif d’identité du Président de l’association
          </li>

          <li>
            · récépissé de déclaration de création.
          </li>
        </ul>
      </p>

      <p>
        En outre, il est expressément prévu que l’Émetteur se garde la possibilité de demander les documents précités permettant d’identifier l’Utilisateur et le bénéficiaire effectif du Compte conformément à la réglementation applicable dès l’ouverture du Compte.
      </p>

      <h3>8.3 Fonctionnement d'un Compte</h3>

      <h4>8.3.1 Achat de Monnaie Électronique</h4>

      <p>
        L’acquisition de Monnaie Électronique peut être réalisée, par carte bancaire ou tout autre moyen de paiement disponible à travers la solution MANGOPAY, en une ou plusieurs fois. Le montant en numéraire versé par l’Utilisateur est collecté par l’Émetteur en contrepartie d’émission d’unités de Monnaie Électronique pour une valeur nominale équivalente et stockée sur le Compte de l’Utilisateur.
      </p>

      <h4>8.3.2 Remboursement lié à l’annulation d’achat de Monnaie Électronique</h4>

      <p>
        L’Utilisateur détenteur de la Monnaie Électronique peut demander le Remboursement de tout ou partie de la Monnaie Électronique à tout moment avant toute utilisation au profit d’un Bénéficiaire. Un Remboursement doit être valablement demandé par email à l'adresse  [Adresse mail Service Client].
      </p>

      <p>
        Il doit indiquer le montant du Remboursement demandé qui peut être partiel ou total. L’Émetteur ajuste, en conséquence, le nombre d’unités de Monnaie Électronique émises par lui et détenues par l’Utilisateur sur le Compte. L’Émetteur initie un ordre de crédit de la Carte Bancaire dans un délai de 5 (cinq) Jours Ouvrés suivants la réception de la demande de l’Utilisateur.
      </p>

      <h4>8.3.3 Détention de Monnaie Électronique</h4>

      <p>
        Le montant de Monnaie Électronique est détenu, à due concurrence, par l’Utilisateur sur le Compte :

        <ul className="no-list-type">
          <li>
            · jusqu’à la date de Remboursement, ou
          </li>

          <li>
            · jusqu'à la date de réalisation d’une Opération de paiement.
          </li>
        </ul>
      </p>

      <h4>8.3.4 Utilisation de la Monnaie Électronique en vue de réaliser une Opération de paiement</h4>

      <p>
        Le montant des Opérations de paiement vient s’imputer sur le montant de Monnaie Électronique inscrite sur leCompte. Lorsque le montant ainsi inscrit est inférieur au prix de l’Opération de Paiement, l’Utilisateur peut s’acquitter du complément de prix nécessaire en utilisant l’un des moyens de paiement acceptés le cas échéant par le Site. A l’inverse, lorsqu’il existe un solde résiduel de Monnaie Électronique sur le Compte, après l’Opération de Paiement, ce dernier peut donner lieu, suivant la décision de l’Utilisateur à une nouvelle Opération de Paiement.
      </p>

      <p>
        L’Émetteuret le Distributeur demeurent étrangers au lien de droit existant entre l’Utilisateur et le Bénéficiaire de l’Opération de paiement. L’Émetteur et le Distributeur ne sauraient être tenus responsables des fautes, manquements ou négligence de l’Utilisateur ou du Bénéficiaire l’un envers l’autre.
      </p>

      <p>
        La Monnaie Électronique est transférée à la suite de l’exécution d’une Opération de paiement au profit du ou desBénéficiaires.
      </p>

      <h4>8.3.5 Transmission et exécution d’un ordre de Remboursement</h4>

      <p>
        Lorsqu’il souhaite effectuer un Remboursement, l’Utilisateur du Compte procède à son identification sur le Site en indiquant son User (adresse mail valide) et son mot de passe. Il remplit le formulaire de demande de Remboursement dans la section adéquate et communique le cas échéant les pièces justificatives demandées par l’Émetteur. La demande de Remboursement devient irrévocable, lorsque l’Utilisateur clique sur l’onglet de validation du formulaire. Le Distributeur adresse alors un email de confirmation à l’Utilisateur, puis procède à l’opération de Remboursement suivant le formulaire.
      </p>


      <h3>8.4 Opposition d’Identifiant contestation d’Opération et Reporting</h3>

      <h4>8.4.1 Opposition d’Identifiant</h4>

      <p>
        L’Utilisateur doit informer le Distributeur de la perte ou du vol de son Identifiant, du détournement ou de touteutilisation non autorisée de celui-ci ou de ses données dès qu’il en a connaissance afin d’en demander le blocage. Cette déclaration doit être réalisée par l’un des moyens suivants:

        <ul className="no-list-type">
          <li>
            · par appel téléphonique au service client du Distributeur au numéro : [numéro de téléphone Service Client] ;
          </li>

          <li>
            · directement par message électronique à l’adresse suivante : [Adresse mail Service Client].
          </li>
        </ul>
      </p>

      <p>
        L’Émetteur par l’intermédiaire du Distributeur exécutera immédiatement la demande de mise en opposition de l’Identifiant concerné. L’événement sera enregistré et horodaté. Un numéro d’opposition avec horodatage sera communiqué à l’Utilisateur. Une confirmation écrite de cette mise en opposition sera adressée par leDistributeur à l’Utilisateur concerné par message électronique. L’Émetteur prend en charge le dossier sur le plan administratif et conserve toutes les traces pendant 18 (dix-huit) mois. Sur demande écrite de l’Utilisateur et avant l’expiration de ce délai, l’Émetteur communiquera une copie de cette opposition.
      </p>

      <p>
        Toute demande d’opposition doit être confirmée sans délai par l’Utilisateur concerné, par lettre signée de ce dernier, remise ou expédiée sous pli recommandé, ou email, à l’Émetteurà l’adresse postale en tête des présentes ou à l’adresse suivante : [Adresse mail Service Client]
      </p>

      <p>
        L’Émetteur et le Distributeur ne sauraient être tenus pour responsable des conséquences d’une opposition par télécopie ou courriel, qui n’émanerait pas de l’Utilisateur.
      </p>

      <p>
        Une demande d’opposition est réputée faite à la date et à l’heure de réception effective de la demande par le Distributeur. En cas de vol ou d’utilisation frauduleuse de l’Identifiant, l’Émetteur est habilité à demander par l’intermédiaire du Distributeur, un récépissé ou une copie du dépôt de plainte à l’Utilisateur qui s’engage à y répondre dans les plus brefs délais.
      </p>

      <h4>8.4.2 Contestation d’une Opération</h4>

      <p>
        Pour toute réclamation relative aux opérations réalisées par l’Émetteur dans le cadre des présentes, telles qu’une Opération de Paiement ou toute opération de débit ou de crédit du Compte de l’Utilisateur au titre notamment d’un Achat de Monnaie Électronique, d’un Retrait ou d’un Remboursement, l’Utilisateur est invité à s’adresser au service client du Distributeur ou à l’adresse indiquée à cet effet dans les Conditions Générales du Site.
      </p>

      <p>
        L’Utilisateur qui souhaite ainsi contester une Opération qu’il estime non autorisée ou mal exécutée doit transmettre sa demande au Distributeur dans les plus brefs délais et avant l’expiration d’un délai de 13 (treize) mois à compter de la date de l’Opération en question (une « Contestation »).
      </p>

      <p>
        La responsabilité de l’Émetteur et du Distributeur ne sauraient en aucun cas être engagée en cas de faute de l’Utilisateur, de manquement intentionnel ou constitutif d’une négligence grave à ses obligations, de transmission tardive d’une Opposition ou d’une Contestation ou de mauvaise foi.
      </p>

      <p>
        Après validation d’une Contestation par l’Émetteur, ce dernier veillera à rétablir sous forme d’un crédit temporaire en unités de Monnaie Électronique le Compte de Monnaie Électronique de l’Utilisateur dans l’état dans lequel il était avant la réalisation de l’Opération contestée.
      </p>

      <h4>8.4.3 Reporting</h4>

      <p>
        L’Émetteur maintiendra dans ses livres le Compte de l’Utilisateur pendant une durée résiduelle de 13 (treize) mois à compter de la date de chaque Opération de Paiement afin de permettre à l’Utilisateur de formuler d’éventuelles Contestations. L’Utilisateur peut à tout moment obtenir, en ligne sur le Site, un état détaillé des Opérations de Paiement qu’il a réalisées.
      </p>

      <p>
        Après l’exécution de toute Opération, l’Utilisateur recevra par courrier du Distributeur les informations suivantes :

        <ul className="no-list-type">
          <li>
            a) Une référence permettant d'identifier l'Opération concernée ;
          </li>
          <li>
            b) Le cas échéant, les informations relatives aux parties impliquées dans
            l’Opération ;
          </li>
          <li>
            c) Le montant de l'Opération concernée ainsi que, le cas échéant, l’objet de
            l’Opération réalisée ;
          </li>
          <li>
            d) Le montant détaillé des Frais applicables le cas échéant ;
          </li>
          <li>
            e) Le cas échéant, la date de réception de l'ordre correspondant et/ou la
            date à laquelle est exécuté letransfert de Monnaie Électronique correspondant.
          </li>
        </ul>
      </p>

      <h3>8.5 Modification du Contrat</h3>

      <p>
        L’Émetteur se réserve le droit, à tout moment, de modifier les Conditions Particulières d’Utilisation. Elles sont rendues accessibles par le Distributeur à tous les Utilisateurs à l’adresse fournie lors de leur inscription.
      </p>

      <p>
        Tout Utilisateur peut refuser les modifications proposées et doit notifier son refus au Service Client du Distributeur par lettre recommandée avec avis de réception avant la date d’entrée en vigueur des modifications proposées (cachet de la Poste faisant foi) à [Adresse Distributeur] défaut d’avoir notifié son refus avant la date d’entrée en vigueur indiquée, ou, à défaut, avant un délai de [7] jours à compter de leur mise en ligne sur le Site, l’Utilisateur est réputé accepter les modifications proposées. Les relations entre les Parties après la date d’entrée en vigueur seront alors régies par la nouvelle version des Conditions Particulières d’Utilisation.
      </p>

      <p>
        Il est par conséquent important que l’Utilisateur consulte ses emails et lise régulièrement les Conditions Particulières d’Utilisation accessibles en ligne sur le Site à tout moment.
      </p>

      <p>
        En cas de refus par l’Utilisateur, ce refus donnera lieu, sans frais, la résiliation des Conditions Particulièresd’Utilisation, ainsi qu’au Remboursement des unités de Monnaie Électronique lui appartenant.
      </p>

      <h3>8.6 Responsabilité de l’Émetteur au titre de l'accès au Site</h3>

      <p>
        L’Émetteur ne saurait être tenu responsable à l’égard de l’Utilisateur des éventuelles erreurs, omissions, interruptions ou retards des opérations réalisées via le Site résultant d’un accès non autorisé à ce dernier.
      </p>


      <p>
        L’Émetteur ne saurait d’avantage être tenu responsable des vols, destructions ou communications non autorisées de données résultant d’un accès non autorisé au Site.
      </p>


      <p>
        L’Émetteur se réserve le droit de suspendre temporairement l'accès au Compte en ligne pour des raisonstechniques ou de maintenance sans que ces opérations n'ouvrent droit à une quelconque indemnité. Il s'engage àlimiter ce type d'interruptions au strict nécessaire.
      </p>


      <p>
        Le Distributeur est seul responsable de la sécurité et de la confidentialité des données échangées dans le cadre de l'utilisation du Site conformément aux Conditions Générales du Site, l’Émetteur étant responsable de la sécurité et de la confidentialité des données qu’il échange avec l’Utilisateur dans le cadre des présentes au titre de la création et de la gestion de son Compte, ainsi que des Opérations afférentes au Compte.
      </p>


      <h3>8.7 Cas d’exclusion de responsabilité de l’Émetteur</h3>

      <p>
        L’Émetteur n'intervient en aucune manière dans les Transactions. L’Émetteur n'exerce aucun contrôle sur la conformité, la sécurité, la licéité, les caractéristiques et le caractère approprié des produits objet d’une Transaction. À cet égard, il appartient à l’Utilisateur de prendre toutes les informations utiles avant de procéder à une Transaction en toute connaissance de cause. Chaque Transaction réalisée par l’Utilisateur donne naissance à un contrat directement formé entre lui et le ou les Bénéficiaires auquel l’Émetteur est étranger. Ce dernier ne pourra en conséquence être tenu responsable de l’inexécution ou de la mauvaise exécution des obligations qui en résulte, ni des préjudices éventuels causé à l’Utilisateur à ce titre.
      </p>

      <p>
        Nonobstant toute disposition contraire dans le présent Contrat, la responsabilité de l’Émetteur à l’égard d’un Utilisateur est limitée à la réparation des dommages directs causés par l’inexécution d’une obligation contractuelle prévue aux présentes.
      </p>


      <h3>8.8 Engagements de l’Utilisateur</h3>

      <p>
        L’Utilisateur garantit qu’aucun élément de son profil sur le Site ne porte atteinte aux droits de tiers ni n'est contraire à la loi, à l’ordre public et aux bonnes mœurs.
      </p>

      <p>
        Il s’engage à ne pas :

        <ul className="no-list-type">
          <li>
            ·         Exécuter le Contrat d’une manière illégale ou dans des conditions susceptibles d'endommager, dedésactiver, de surcharger ou d'altérer le Site ;
          </li>

          <li>
            ·         Usurper l'identité d'une autre personne ou entité, falsifier ou dissimuler son identité, son âge ou créerune fausse identité quelconque ;
          </li>

          <li>
            ·         Diffuser des données ou informations personnelles relatives à un tiers, telles que des adresses postales,numéros de téléphone, adresses électroniques, numéros de cartes bancaire, etc.
          </li>
        </ul>
      </p>


      <p>
        En cas de manquement à ces obligations, l’Émetteur se réserve le droit de prendre toute mesure appropriée afin de faire cesser les agissements concernés. Il sera également en droit de suspendre, supprimer et/ou bloquer son accès au Compte.
      </p>



      <p>
        Sans préjudice des actions judiciaires engagées par des tiers, l’Émetteur est en droit d’exercer à titre personnel toute action en justice visant à réparer les préjudices qu’il aurait personnellement subis du fait des manquements qui lui sont imputables au titre du présent Contrat.
      </p>


      <p>
        Si l’Utilisateur constate un manquement aux obligations précitées, il est invité à signaler à l’Émetteur ces agissements en contactant le service client à contact@Leetchi-corp.com.
      </p>


      <h3>8.9 Durée des Conditions Particulières d’Utilisation et résiliation</h3>

      <p>
        Les Conditions Particulières d’Utilisation sont conclues pour une durée indéterminée à compter de la réception parl’Utilisateur de l’email de confirmation de son inscription. L’Utilisateur peut à tout moment et moyennant lerespect d’un préavis de 30 (trente) jours calendaires, procéder à la résiliation des Conditions Particulièresd’Utilisation. Cette résiliation emporte résiliation de l’ensemble du Contrat et en conséquence fermeture du Compte. L’Utilisateur doit, pour ce faire, adresser sa notification de résiliation des présentes au service client, par lettre recommandée avec accusé de réception, à l’adresse postale suivante : [Adresse Distributeur]
      </p>


      <p>
        L’Utilisateur devra désigner les coordonnées de son compte bancaire permettant à l’Émetteur de rembourser à l’Utilisateur la Monnaie Électronique figurant au crédit de son Compte. En l’absence d’indication, il appartient à l’Émetteur de suivre les instructions de Remboursement impliquant le remboursement par crédit de la CarteBancaire ayant servi à l’acquisition de la Monnaie Électronique. L’Émetteur est déchargé de toute obligation dès lors qu’il aura confirmé à l’Utilisateur le virement sur le compte bancaire indiqué ou le crédit sur sa Carte Bancaire du montant de Monnaie Électronique.
      </p>


      <p>
        En cas de nomination d’un successeur de l’Émetteur pour émettre la Monnaie Électronique distribuée sur le Site, il appartient au Distributeur de recueillir l’accord express et écrit de l’Utilisateur sur ce changement et d’indiquer à l’Émetteur les modalités de transfert des fonds correspondants à la Monnaie Électronique diminués des frais applicables.
      </p>


      <p>
        En cas de manquement grave, fraude, ou impayés de la part de l’Utilisateur, l’Émetteur se réserve le droit de suspendre ou résilier les présentes par l’envoi d’un email accompagné en cas de résiliation d’une lettre recommandée avec avis de réception. La résiliation entraine la suppression du Compte, le cas échéant leRemboursement de l’Utilisateur. Ces Remboursements pourront dans certains cas être bloqués conformément à la législation en matière de lutte contre le blanchiment de capitaux et le financement du terrorisme.
      </p>


      <p>
        La résiliation des Conditions Générales d’Utilisation à l’initiative de l’Émetteurne peut entrainer aucun droit à indemnité au profit de l’Utilisateur, du Distributeur ou du Bénéficiaire.
      </p>


      <h3>8.10 Droit de rétractation</h3>
      <p>
        L’Utilisateur dispose d’un délai de 14 (quatorze) jours calendaires révolus pour exercer son droit de rétractation, sans avoir à justifier de motif ni supporter de pénalité. Ce délai de rétractation commence à courir à compter du jour de son inscription en tant qu’Utilisateur.
      </p>

      <p>
        L’Utilisateur doit notifier sa demande de rétractation dans le délai imparti au service client du Distributeur par téléphone ou par email et adresser un courrier de confirmation à l’adresse du service client du Distributeur.
      </p>

      <p>
        Au titre de l’exercice de son droit de rétractation, le Contrat sera résilié sans frais dans les conditions et sous les réserves prévues aux articles L.121-20-8 et suivants du Code de la consommation.
      </p>

      <h3>8.11 Règles de lutte contre le blanchiment et le financement du terrorisme</h3>

      <p>
        L’Émetteur est soumis à l’ensemble de la réglementation luxembourgeoise et française relative à la lutte contre le blanchiment et le financement du terrorisme.
      </p>

      <p>
        En application des dispositions de droit français et luxembourgeois, relatifs à la participation des organismes financiers à la lutte contre le blanchiment des capitaux et le financement des activités terroristes, l’Émetteur est tenu de s’informer auprès de tout Utilisateur pour toute opération ou relation d’affaires de l’origine, de l’objet etde la destination de l’opération ou de l’ouverture du compte. Il doit, par ailleurs, réaliser toutes les diligencesnécessaires à l’identification de l’Utilisateur et le cas échéant, du bénéficiaire effectif du Compte et/ou desOpérations liées à celui-ci. L’Utilisateur s’engage à faire toute diligence pour permettre à l’Émetteur d’effectuer un examen approfondi de l’opération, à l’informer de toute opération exceptionnelle par rapport aux opérations habituellement enregistrées dans le cadre des présentes et à lui fournir tout document ou information requis.
      </p>

      <p>
        L’Utilisateur reconnaît que l’Émetteur peut mettre un terme ou reporter à tout moment l’usage d’un identifiant, l’accès à un Compte ou l’exécution d’une opération ou d’un Remboursement en l’absence d’élément suffisant sur son objet ou sa nature. Il est informé qu’une opération réalisée dans le cadre des présentes peut faire l’objet de l’exercice du droit à la communication de la cellule de renseignement financier nationale.
      </p>

      <p>
        L’Utilisateur peut, conformément à la réglementation, accéder à toutes les informations ainsi communiquées sous réserve que ce droit d’accès ne remette pas en cause la finalité de lutte contre le blanchiment des capitaux et le financement du terrorisme lorsque ces données sont relatives au demandeur.
      </p>

      <p>
        Aucune poursuite et aucune action en responsabilité civile ne peut être intentée ni aucune sanction professionnelle prononcée contre l’Émetteur, ses dirigeants ou ses préposés qui ont fait de bonne foi les déclarations de soupçon auprès de leur autorité nationale.
      </p>

      <h3>8.12 Données à caractère personnel et secret professionnel</h3>

      <p>
        L’Utilisateur accepte que les coordonnées et informations nominatives le concernant recueillies par l’Émetteur dans le cadre des présentes soient transmises aux sociétés du groupe auquel appartiennent l’Émetteur ainsi qu’aux prestataires opérationnels avec lesquelles celui-ci est en relation contractuelle aux fins d’exécution des transactions et services proposés sous réserve que ces tiers destinataires des données à caractère personnel soient soumis à une réglementation garantissant un niveau de protection suffisante tel que défini à l’article 561-7 II b du Code Monétaire et Financier. La liste des tiers destinataires d’informations couvertes par le secret professionnel est accessible sur simple demande auprès du responsable de la conformité de l’Émetteur. Ces informations sont conservées par lui ou toute société mandatée à cet effet, dans les conditions légales et réglementaires.
      </p>

      <p>
        Certaines informations recueillies et détenues par l’Émetteur dans le cadre des présentes peuvent donner lieu à l’exercice du droit d’accès et de rectification dans les conditions prévues par la loi n°78-17 du 6 janvier 1978 modifiée relative à l’informatique, aux fichiers et aux libertés. Tout Utilisateur peut à tout moment obtenir une copie des informations le concernant sur simple demande adressée au correspondant CNIL de l’Émetteur. Il peut solliciter à cette même adresse une suppression ou une rectification de ces informations par écrit. Il peut à tout moment s’opposer à la réception de sollicitations commerciales, faire modifier ses coordonnées, s’opposer à leur communication en adressant une notification par courrier recommandée ou courriel suivie d’un accusé de réception à l’adresse du service client de l’Émetteur. Ce courrier devra indiquer nom, prénom, et Identifiant.
      </p>

      <p>
        Conformément à la réglementation en vigueur, il doit également être signé, accompagné de la photocopie d’un titre d’identité portant la signature de l’Utilisateur et préciser l’adresse à laquelle il souhaite recevoir la réponse.
      </p>

      <p>
        Une réponse lui sera adressée à l’adresse indiquée dans un délai de 2 (deux) mois suivant la réception de sa demande.
      </p>

      <p>
        L’Émetteur conservera les informations et données à caractère personnel pendant la durée maximum légale ou réglementaire applicable en fonction de la finalité de chacun des traitements de données.
      </p>

      <p>
        Les conditions de collecte, de détention et d’accès des données à caractère personnel recueillies par le Distributeur et sous sa responsabilité au titre de l’accès au Site, sont régies aux termes des Conditions Généralesdu Site ainsi que de la charte de confidentialité accessible sur le Site.
      </p>

      <h3>8.13 Comptes inactifs</h3>

      <p>
        Le Distributeur et l’Émetteur se réservent le droit de clôturer des comptes inactifs depuis plus de 24 mois.
      </p>

      <h3>8.14 Force majeure</h3>

      <p>
        Les Parties ne seront pas tenues pour responsables, ou considérées comme ayant failli au titre des présentes, en cas de retard ou inexécution, lorsque leur cause est liée à un cas de force majeure tel que défini par la jurisprudence des tribunaux français.
      </p>

      <h3>8.15 Incessibilité</h3>

      <p>
        Le Contrat ne peut faire l'objet d'une cession totale ou partielle par l’Utilisateur, à titre onéreux ou gratuit. Il est par suite interdit de céder à un tiers l'un quelconque des droits ou obligations qu’il tient des présentes. En cas de manquement à cette interdiction, outre la résiliation immédiate des présentes, sa responsabilité pourra être engagée par l’Émetteur.
      </p>

      <h3>8.16 Convention de preuve</h3>

      <p>
        Toutes les données reprises de façon inaltérable, fiable, et sécurisée dans la base de données informatique de l’Émetteur relatives notamment aux ordres de paiement et confirmations reçues de l’Utilisateur, aux notifications envoyées, aux accès, Retrait, Remboursement feront foi entre les parties jusqu’à preuve du contraire.
      </p>

      <h2>9. Propriété intellectuelle</h2>

      <p>
        PAYMYTABLE conserve la propriété exclusive des droits attachés aux applications mobiles, logiciels et site internet PAYMYTABLE, ainsi qu’aux noms, marques, noms de domaines, logos ou autres signes distinctifs respectifs qu’elle détient.
      </p>

      <p>
        Les Utilisateurs reconnaissent que seul leur usage au titre du présent Contrat ne leur permet pas de revendiquer des droits de propriété intellectuelle d’aucune sorte sur ceux-ci, demeurant la propriété entière de PAYMYTABLE. Le présent Contrat ne confère en conséquence aucune cession ou licence de droits.
      </p>

      <h2>10. Indépendance des stipulations contractuelles</h2>

      <p>
        Si l'une quelconque des stipulations des présentes est tenue pour nulle ou sans objet, elle sera réputée non écrite et n'entraînera pas la nullité des autres stipulations.
      </p>

      <p>
        Si une ou plusieurs stipulations des présentes deviennent caduques ou sont déclarées comme telles en application d'une loi, d'un règlement ou à la suite d'une décision définitive rendue par une juridiction compétente, les autres stipulations conserveront leur force obligatoire et leur portée. Les stipulations déclarées nulles et non valides seront alors remplacées par les stipulations qui se rapprocheront le plus quant à leur sens et à leur portée des stipulations initialement convenues.
      </p>

      <h2>11. Droit applicable et juridiction compétente</h2>

      <p>
        Sauf en cas d'application d'une loi d’ordre public (laquelle ne s'appliquera que dans les strictes limites de sonobjet), il est expressément stipulé que les Conditions Générales d’Utilisation ainsi que les Conditions Particulières relatives à la monnaie électronique sont soumises à la loi française et que tout litige entre les Parties autitre de ces dernières seront soumises à la juridiction des tribunaux français compétents.
      </p>

    </div>
  );

}



// WEBPACK FOOTER //
// ./scripts/pages/other/CGUPage.js